<template>
  <div>
    <v-dialog v-model="getGlobalConfirmDelete" persistent max-width="500">
      <v-card>
        <v-card-title
          :style="{
            'backdround-color': getThemeColor,
            color: getSecondaryColor,
          }"
          class="text-h5 lighten-2"
          >Confirm Delete</v-card-title
        >

        <v-card shaped elevation="12" outlined class="mx-10">
          <v-container>
            <v-row>
              <v-btn
                rounded
                class="mt-4 mb-10 mx-auto"
                :style="{
                  'background-color': 'red',
                  color: 'white',
                }"
                @click="deleteConfirmed(true)"
              >
                <v-icon left>mdi-times</v-icon>
                Delete {{ item }}
              </v-btn>
            </v-row>
          </v-container>
        </v-card>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :style="getThemeStyle" dark @click="deleteConfirmed(false)"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: String,
      default: "Item(s)",
    },
  },
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getGlobalConfirmDelete() {
      return this.$store.getters.getGlobalConfirmDelete;
    },
  },
  methods: {
    deleteConfirmed(choice) {
      this.$emit("delete-confirmed", choice);
      this.$store.commit("setGlobalConfirmDelete", false);
    },
  },
};
</script>

<style></style>
